import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Buffer } from 'buffer';
import store from "./store"
import $ from 'jquery';
window.jQuery = $;
window.Buffer = Buffer;



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter
        basename={process.env.PUBLIC_URL}
    >
        <Provider store={store}>
            <App />
        </Provider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
